import css from 'styled-jsx/css';

const styles = css.global`#hero-santander-financiamentos {
    height: 454px;
    background: #ec0000;
}

#hero-santander-financiamentos .ctn-home-24 {
    display: flex;
    flex-direction: column;
    align-items: center;
    height: 454px;
    justify-content: center;
    gap: 10px;
}

#hero-santander-financiamentos .hero-img {
    margin-bottom: -10px;
}

#hero-santander-financiamentos .hero-contain {
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 16px;
    max-width: 280px;
}

#hero-santander-financiamentos .hero-contain .hero-selo img {
    width: 169px;
}

#hero-santander-financiamentos .hero-contain .hero-texts {
    display: flex;
    flex-direction: column;
    gap: 3px;
    width: 250px;
    margin: 0 auto;
}

#hero-santander-financiamentos .hero-contain .hero-title {
    color: #FFF;
    font-family: "SantanderCondensed";
    font-size: 40px;
    font-style: normal;
    font-weight: 400;
    line-height: 40px; 
}

#hero-santander-financiamentos .hero-contain .hero-sub-title {
    color: #FFF;
    font-family: "SantanderMicroText";
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    letter-spacing: -2%;
    width: 249px;
}

#hero-santander-financiamentos .hero-buttons {
    display: flex;
    flex-direction: column;
    gap: 10px;
}

#hero-santander-financiamentos .hero-buttons a {
    margin: 0 auto;
    width: 100%;
    max-width: 270px;
    height: 50px;
    border-radius: 80px;
    font-size: 20px;
    font-weight: 600;
    padding-bottom: 5px;
}

@media (min-width: 414px) {
    #hero-santander-financiamentos .hero-contain {
        max-width: 326px;
    }

    /* #hero-santander-financiamentos .hero-contain .hero-title {
        font-size: 35px;
        line-height: 35px;
    }

    #hero-santander-financiamentos .hero-contain .hero-sub-title {
        font-size: 16px;
        letter-spacing: -0.32px;
    } */

}

@media (min-width: 600px) {
    #hero-santander-financiamentos .ctn-home-24 {
        flex-direction: row-reverse;
        justify-content: space-between;
    }

    #hero-santander-financiamentos .hero-img {
        margin-bottom: 0;
        max-width: 410px;
    }

    #hero-santander-financiamentos .hero-img img {
        width: 100%;
        /* max-width: 452px; */
    }

    #hero-santander-financiamentos .hero-contain .hero-texts {
        gap: 10px;
    }

    #hero-santander-financiamentos .hero-contain .hero-title {
        font-size: 48px;
        line-height: 48px;
        position: sticky;
        width: 304px;
    }

    #hero-santander-financiamentos .hero-contain {
        max-width: 242px;
        /* width: 100%; */
    }

    #hero-santander-financiamentos .hero-buttons {
        gap: 20px;
    }
}

@media (min-width: 800px) {
    #hero-santander-financiamentos .ctn-home-24 {
        justify-content: space-between;
    }

   

}

@media (min-width: 992px) {
    #hero-santander-financiamentos .ctn-home-24 {
        position: relative;
    }
    
    #hero-santander-financiamentos .hero-contain {
        max-width: 432px;
        margin: 0;
    }

    #hero-santander-financiamentos .hero-contain .hero-texts {
        margin: 0;
        width: auto;
    }

    #hero-santander-financiamentos .hero-contain .hero-title {
        font-size: 64px;
        line-height: 64px;
        width: 400px;
    }

    #hero-santander-financiamentos .hero-contain .hero-sub-title {
        font-size: 25px;
        width: 445px;
    }

    #hero-santander-financiamentos .hero-buttons {
        flex-direction: row;
    }
}

@media (min-width: 1100px) {
    #hero-santander-financiamentos .hero-img img {
        position: absolute;
        right: 40px;
        top: 50px;
        width: 572px;
    }

    
}
/* @media (min-width: 994px) {
    #hero-santander-financiamentos {
        padding-top: 15px;
    }

    #hero-santander-financiamentos .ctn-home-24 {
        justify-content: space-between;
        gap: 0;
    }

    #hero-santander-financiamentos .hero-img {
        max-width: 100%;
        width: 510px;
    }

    #hero-santander-financiamentos .hero-contain {
        max-width: 602px;
    }

    #hero-santander-financiamentos .hero-contain .hero-selo img {
        width: 332px;
    }

    #hero-santander-financiamentos .hero-contain .hero-title,
    #hero-santander-financiamentos .hero-contain .hero-title b {
        font-size: 63px;
        line-height: 63px;
    }

    #hero-santander-financiamentos .hero-contain .hero-sub-title {
        font-size: 32px;
    }
}

@media (min-width: 1100px) {
    #hero-santander-financiamentos {
        padding-top: 0;
    }
} */`;

export default styles;